export enum AvatarSize {
  xsmall = 'xsmall',
  small = 'small',
}
